// src/app/services/settings/assistant-default.ts
//
// The 12b ruling, in one place so it can be pinned.
//
// The assistant panel is CLOSED by default. It took two goes to get right, and
// both failures were the same mistake in different clothes: treating an absent
// preference as an explicit "open".
//
//   * applySettingsAfterAuth did `!!s.appearance?.startAiCollapsed`, so an
//     absent setting coerced to false and was then written to localStorage,
//     overwriting the default on every login.
//   * the SERVER model default was False, so every user with no stored row was
//     served an explicit "open" and the client-side default was unreachable.
//
// A user who has actually chosen still wins, in either direction.

/**
 * Resolve whether the assistant starts collapsed.
 *
 * Only an explicit boolean counts as a choice. `undefined` and `null` mean the
 * user has not chosen, which resolves CLOSED — never open.
 */
export function resolveAiCollapsed(stored: unknown): boolean {
  return typeof stored === "boolean" ? stored : true;
}

/** The same rule for the localStorage cache, where absence is `null`. */
export function resolveAiCollapsedFromCache(raw: string | null): boolean {
  return raw === null ? true : raw === "true";
}
